import stickybits from 'stickybits';

jQuery( function( $ ) {
	$( 'button#mobile-button' ).on( 'click', function() {
		$( '.ac-nav-collapse' ).toggleClass( 'mobile-open' );
	} );

	$( '.nav-menu > .menu-item-has-children' ).append( '<div class="toggle-sub-menu"><i class="fa fa-plus"></i></div>' );

	$( '.toggle-sub-menu' ).on( 'click', function() {
		$( this ).siblings( '.sub-menu' ).toggleClass( 'show-sub-menu' );
		$( this ).toggleClass( 'sub-menu-open' );
	} );

	$( '#search-toggle' ).on( 'click', function() {
		$( this ).toggleClass( 'search-open' );

		$( '#search-container' ).slideToggle(
			150,
			function() {
				$( this ).find( '.form-control' ).trigger( 'focus' );
			}
		);
	} );

	$( '#mobile-menu' ).on( 'click', function( e ) {
		$( '.menu' ).toggleClass( 'menuOpen' );
		e.preventDefault();
	} );

	if ( '/' !== window.location.pathname ) {
		$( '.ajdg_grpwidgets a' ).each( function( ) {
			const currentElem = $( this );

			if ( currentElem.attr( 'rel' ) !== 'dofollow' ) {
				currentElem.attr( 'rel', 'nofollow' );
			}
		} );
	}

	$( '.top-navigation__heading' ).on( 'click', function() {
		$( '.top-navigation__heading' ).toggleClass( 'sub-menu-visible' );
		$( '.submenu-overlay' ).toggleClass( 'submenu-overlay-show' );
	} );

	const stickyArgs = {
		useStickyClasses: true,
	};

	// Setting sticky menu offset to the same height as wpadminbar.
	if ( 0 < $( 'body.admin-bar' ).length ) {
		stickyArgs.stickyBitStickyOffset = 32;
	}

	stickybits( '.top-links-wrapper', stickyArgs );
} );
